export const PREFIX = 'rankings'

export const FETCH_RANKINGS_COUNTRIES = `${PREFIX}/FETCH_RANKINGS_COUNTRIES`
export const FETCH_RANKINGS_COUNTRIES_ERROR = `${PREFIX}/FETCH_RANKINGS_COUNTRIES_ERROR`
export const FETCH_RANKINGS_COUNTRIES_SUCCESS = `${PREFIX}/FETCH_RANKINGS_COUNTRIES_SUCCESS`

export const FETCH_RANKING_HOURLY_COUNTRIES = `${PREFIX}/FETCH_RANKING_HOURLY_COUNTRIES`
export const FETCH_RANKING_HOURLY_COUNTRIES_ERROR = `${PREFIX}/FETCH_RANKING_HOURLY_COUNTRIES_ERROR`
export const FETCH_RANKING_HOURLY_COUNTRIES_SUCCESS = `${PREFIX}/FETCH_RANKING_HOURLY_COUNTRIES_SUCCESS`

export const FETCH_RANKING_HOURLY_STORES = `${PREFIX}/FETCH_RANKING_HOURLY_STORES`
export const FETCH_RANKING_HOURLY_STORES_ERROR = `${PREFIX}/FETCH_RANKING_HOURLY_STORES_ERROR`
export const FETCH_RANKING_HOURLY_STORES_SUCCESS = `${PREFIX}/FETCH_RANKING_HOURLY_STORES_SUCCESS`

export const SET_SELECTED_COUNTRY = `${PREFIX}/SET_SELECTED_COUNTRY`
export const SET_SELECTED_COUNTRY_COMPARED = `${PREFIX}/SET_SELECTED_COUNTRY_COMPARED`

export const SET_SELECTED_STORE = `${PREFIX}/SET_SELECTED_STORE`
export const SET_SELECTED_STORE_COMPARED = `${PREFIX}/SET_SELECTED_STORE_COMPARED`

export const SET_INDICATOR = `${PREFIX}/SET_INDICATOR`
export const SET_RANKING = `${PREFIX}/SET_RANKING`
export const SET_SORT = `${PREFIX}/SET_SORT`
export const TOGGLE_ARE_FILTERS_EXPANDED = `${PREFIX}/TOGGLE_ARE_FILTERS_EXPANDED`
export const TOGGLE_COLLAPSED = `${PREFIX}/TOGGLE_COLLAPSED`

export const OPEN_FILTER_COUNTRY_MODAL = `${PREFIX}/OPEN_FILTER_COUNTRY_MODAL`
export const HIDE_FILTER_COUNTRY_MODAL = `${PREFIX}/HIDE_FILTER_COUNTRY_MODAL`

export const SET_FILTER_COUNTRY_INPUT = `${PREFIX}/SET_FILTER_COUNTRY_INPUT`
export const SET_SELECTED_COUNTRIES = `${PREFIX}/SET_SELECTED_COUNTRIES`
export const TOGGLE_ITEM = `${PREFIX}/TOGGLE_ITEM`

export const TOGGLE_WEEKLY = `${PREFIX}/TOGGLE_WEEKLY`

export enum RANKINGS {
  'COMPANIES_STATIONARY' = 'companiesStationary',
  'WORST_20_SHOPS' = 'worst20Shops',
  'BEST_20_SHOPS' = 'best20Shops',
  'DISTRICT' = 'district',
  'RKS' = 'rks',
  'WEBSITE_ECOMMERCE' = 'websiteEcommerce',
  'STORES_OPEN_WITHIN_12_MONTHS' = 'storesOpenWithin12Months',
  'STORES_OPEN_WITHIN_30_DAYS' = 'storesOpenWithin30Days',
  'COMPANIES_ECOMMERCE' = 'companiesEcommerce',
  'COMPANIES_BY_CHANNELS' = 'companiesByChannels',
  'CLUB_CARD' = 'companiesClubCard',
  'HOURS_REVENUE' = 'hoursRevenue',
}

export enum INDICATORS {
  'REVENUE_CURRENT' = 'revenueCurrent',
  'REVENUE_CHANGE' = 'revenueChange',
  'REVENUE_PER_STORE_CURRENT' = 'revenuePerStoreCurrent',
  'SHARE_CURRENT' = 'shareCurrent',
  'TRAFFIC_CURRENT' = 'trafficCurrent',
  'TRAFFIC_PER_STORE_CURRENT' = 'trafficPerStoreCurrent',
  'CONVERSION_CURRENT' = 'conversionCurrent',
  'TRANSACTION_VALUE_CURRENT' = 'transactionValueCurrent',
  'CLUB_CARDS_CURRENT' = 'clubCardsCurrent',
  'CLUB_SHARE_CURRENT' = 'clubShareCurrent',
  'REVENUE_CLUB_CURRENT' = 'revenueClubCurrent',
  'TRANSACTION_VALUE_CLUB_CURRENT' = 'transactionValueClubCurrent',
  'REVENUE_PER_M2_CURRENT' = 'revenuePerM2Current',
  'COMPANIES_ECOMMERCE' = 'companiesEcommerce',
  'COMPANIES_NECOMMERCE' = 'companiesStationary',
  'COMPANIES_ECOMMERCE_ORDERS' = 'companiesEcommerceOrders',
  'STORES_ECOMMERCE_ORDERS' = 'storesEcommerceOrders',
  'STORES_NECOMMERCE' = 'storesStationary',
  'STORES_ECOMMERCE' = 'websiteEcommerce',
}

export const PERCENT_INDICATORS = [
  INDICATORS.COMPANIES_ECOMMERCE_ORDERS,
  INDICATORS.STORES_ECOMMERCE,
  INDICATORS.STORES_ECOMMERCE_ORDERS,
]

export const SORT = {
  ...INDICATORS,
  INDICATOR: 'indicator',
  RANK: 'rank',
  TITLE: 'title',
}

export const ORDER = {
  ASC: 'asc',
  DESC: 'desc',
}

export enum AVAILABLE_COLUMNS_TYPES {
  'DEFAULT' = 'default',
  'CURRENCY' = 'currency',
  'PERCENT' = 'percent',
  'PERCENT_SIMPLE' = 'percent-simple',
  'PROGRESS' = 'progress',
  'PROGRESS_FULL' = 'progress-full',
}
